import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const API_URL = 'planes/'; // Ruta relativa (Django ya tiene /api/ en baseURL)

export interface Plan {
    PlanID: number;
    NombrePlan: string;
    Comentarios: string | null;
    estado: boolean;
    fecha_creacion: string;
}
// GET: Obtener todos los planes
export const fetchPlanes = async (): Promise<Plan[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get<Plan[]>(API_URL);
        return response.data;
    });
};

// POST: Crear un nuevo plan
export const createPlan = async (data: {
    NombrePlan: string;
    Comentarios?: string;
    estado?: boolean;
}) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.post(API_URL, data);
        return response.data;
    });
};

// PUT: Actualizar un plan existente
export const updatePlan = async (
    id: number,
    data: {
        NombrePlan: string;
        Comentarios?: string;
        estado?: boolean;
    }
) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.put(`${API_URL}${id}/`, data);
        return response.data;
    });
};

// DELETE: Eliminar un plan
export const deletePlan = async (id: number) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.delete(`${API_URL}${id}/`);
        return response.data;
    });
};


